import Vue from 'vue'
import Router from 'vue-router'
import Recover from '@/views/login/recover'
import Login from '@/views/login/index'
import Layout from '@/components/layout/layout'
import Platform from '@/views/platform/platform'
import ChangeEmail from '@/views/platform/changeEmail'

/*系统配置*/
const Application = resolve => require(['@/views/systemConfig/application'], resolve);
const ApplicationOper = resolve => require(['@/views/systemConfig/applicationOper'], resolve);
const RouterConfig = resolve => require(['@/views/systemConfig/routerConfig'], resolve);
const RouterConfigOper = resolve => require(['@/views/systemConfig/routerConfigOper'], resolve);
const MenuConfig = resolve => require(['@/views/systemConfig/menuConfig'], resolve);
const IndexConfig = resolve => require(['@/views/systemConfig/indexConfig'], resolve);

/*组织管理*/
const Organazation  = reslove => require(['@/views/organazation/organazation'], reslove);
const OrganazationOper  = reslove => require(['@/views/organazation/organazationOper'], reslove);
const School  = reslove => require(['@/views/organazation/school'], reslove);
const SchoolTransfer  = reslove => require(['@/views/organazation/schoolTransfer'], reslove);
const SchoolOper  = reslove => require(['@/views/organazation/schoolOper'], reslove);
const SchoolInfo  = reslove => require(['@/views/organazation/schoolInfo'], reslove);
const SchoolInfoOper  = reslove => require(['@/views/organazation/schoolInfoOper'], reslove);
const Class  = reslove => require(['@/views/organazation/class'], reslove);
const ClassOper  = reslove => require(['@/views/organazation/classOper'], reslove);

/*组织授权*/
const OrgGava  = reslove => require(['@/views/organazation/orgGava'], reslove);
const SchoolGava  = reslove => require(['@/views/organazation/schoolGava'], reslove);

/*用户管理*/
const UserConfig  = reslove => require(['@/views/userManage/userConf'], reslove);
const DistributeRole  = reslove => require(['@/views/userManage/distributeRole'], reslove);
const RoleConfig  = reslove => require(['@/views/userManage/roleConfig'], reslove);
const AddRoles  = reslove => require(['@/views/userManage/addRoles'], reslove);
const AddUsers  = reslove => require(['@/views/userManage/addUsers'], reslove);

/*账号管理*/
const BaseInfo  = reslove => require(['@/views/account/baseInfo'], reslove);
const PassManage  = reslove => require(['@/views/account/passManage'], reslove);

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/' + process.env.PUBLICPATH + '/',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/recover',
      name: 'recover',
      component: Recover,
      meta: {powerBtn: false}
    },
    {
      path: '/',
      redirect: {name: 'platform'}
    },
    {
      path: '/platform',
      name: 'platform',
      component: Platform,
      meta: {powerBtn: false}
    },
    {
      path: '/change_email',
      name: 'change_email',
      component: ChangeEmail,
      meta: {powerBtn: false}
    },
    {
      path: '/index',
      name: 'index',
      redirect: {name: 'baseInfo'},
      meta: {powerBtn: true},
      component: Layout,
      children: [
        {path: 'application', name: 'application', component: Application},
        {path: 'applicationOper/:type', name: 'applicationOper', component: ApplicationOper},
        {path: 'router_config', name: 'router_config', component: RouterConfig},
        {path: 'router_config_oper', name: 'router_config_oper', component: RouterConfigOper, meta: {nav: '新增'}},

        {path: 'menu', name: 'menu', component: MenuConfig},
        {path: 'home', name: 'home', component: IndexConfig},

        {path: 'organization', name: 'organization', component: Organazation, meta: {powerBtn: true}},
        {path: 'organizationOper/:type', name: 'organizationOper', component: OrganazationOper},
        {path: 'school', name: 'school', component: School, meta: {powerBtn: true}},
        {path: 'schoolOper/:type', name: 'schoolOper', component: SchoolOper},
        {path: 'schoolTransfer/:type', name: 'schoolTransfer', component: SchoolTransfer, meta: {nav: '转辖区'}},
        {path: 'school_info', name: 'school_info', component: SchoolInfo, meta: {powerBtn: true}},
        {path: 'school_info_oper/:type', name: 'school_infoOper', component: SchoolInfoOper, meta: {nav: '编辑'}},
        {path: 'class', name: 'class', component: Class, meta: {powerBtn: true}},
        {path: 'classOper/:type', name: 'classOper', component: ClassOper, meta: {nav: '新增'}},
        {path: 'classEdit/:type', name: 'classEdit', component: ClassOper, meta: {nav: '修改', isEdit: true, isSee: false}},
        {path: 'classSee', name: 'classSee', component: ClassOper, meta: {nav: '查看', isEdit: true, isSee: true}},

        {path: 'org_gava', name: 'org_gava', component: OrgGava, meta: {nav: '机构授权'}},
        {path: 'school_gava', name: 'school_gava', component: SchoolGava, meta: {nav: '学校授权'}},

        {path: 'users', name: 'users', component: UserConfig, meta: {nav: '用户管理', powerBtn: true}},
        {path: 'usersAdd/:type', name: 'usersAdd', component: AddUsers, meta: {nav: '新增用户'}},
        {path: 'usersEdit/:type', name: 'usersEdit', component: AddUsers, meta: {nav: '修改用户'}},
        {path: 'usersDistributeRole/:type', name: 'usersDistributeRole', component: DistributeRole, meta: {nav: '分配角色'}},
        {path: 'rolesAdd/:type', name: 'rolesAdd', component: AddRoles, meta: {nav: '新增角色'}},
        {path: 'rolesEdit/:type', name: 'rolesEdit', component: AddRoles, meta: {nav: '修改角色'}},
        {path: 'roles', name: 'roles', component: RoleConfig, meta: {nav: '角色管理', powerBtn: true}},

        {path: 'baseInfo', name: 'baseInfo', component: BaseInfo, meta: {nav: '基本信息'}},
        {path: 'passManage', name: 'passManage', component: PassManage, meta: {nav: '密码修改'}}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js